import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3275d512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon fill" }

import FocusIcon from '@/components/icons/FocusIcon.vue';


interface IMenuItemProps {
	distance: string;
	markerColor: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    distance: { type: String, required: true },
    markerColor: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
	distance: string;
	markerColor: string;
}
_useCssVars(_ctx => ({
  "63f8c346": (props.markerColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createTextVNode(" " + _toDisplayString(props.distance) + " ", 1),
    _createVNode(FocusIcon, { class: "icon" })
  ]))
}
}

})